export default __webpack_public_path__ + "2ce08ea75887dc9d968a728c3af12791.png";